<template>
    <div>
        <el-form  :model="formData" :style="{height: tableHeight+'px',overflowY:'auto'}"  ref="formRef" label-width="140px" size="mini">
            <el-form-item  prop="ywtype" label="业务类型">
                <el-select v-model="formData.ywtype" size="mini" >
                    <el-option v-for="item in typeList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="pzid" label="物料">
                <el-select v-model="formData.pzid" size="mini" filterable remote :remote-method="remoteMethodwl" clearable :disabled="formData.pzclass!=''">
                    <el-option v-for="item in wlList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="pzclass" label="物料大类">
                <el-select v-model="formData.pzclass" size="mini" filterable remote :remote-method="remoteMethodwldl" clearable :disabled="formData.pzid!=''">
                    <el-option v-for="item in wldlList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="issan" label="是否散水">
                <div v-for="(item,i) in YoN">
                    <el-radio v-model="formData.issan" :label="item.id">{{item.text}}</el-radio>
                </div>
            </el-form-item>
            <el-form-item  prop="ischeck" label="是否需要检测">
                <div v-for="(item,i) in YoN">
                    <el-radio v-model="formData.ischeck" :label="item.id">{{item.text}}</el-radio>
                </div>
            </el-form-item>
            <el-form-item  prop="istvnotice" label="是否需要大屏通知">
                <div v-for="(item,i) in YoN">
                    <el-radio v-model="formData.istvnotice" :label="item.id">{{item.text}}</el-radio>
                </div>
            </el-form-item>
            <el-form-item  prop="tvlocation" label="大屏推送区域" >
                <el-input v-model="formData.tvlocation"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="gettype" label="取样形式">
                <el-radio v-model="formData.gettype" :label="1">自取样</el-radio>
                <el-radio v-model="formData.gettype" :label="2">车间取样</el-radio>
                <el-radio v-model="formData.gettype" :label="3">不取样</el-radio>
            </el-form-item>
            <el-form-item  prop="pcnumPrefix" label="批次号前缀">
                <el-input v-model="formData.pcnumPrefix"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="unit" label="单位">
                <el-radio-group v-model="formData.unit">
                    <el-radio :label="1">日</el-radio>
                    <el-radio :label="2">月</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item  prop="pcmerge" label="合并标识">
                <el-input v-model="formData.pcmerge"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="dateformat" label="日期格式">
                <el-input v-model="formData.dateformat"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="pzcode" label="产品代码">
                <el-input v-model="formData.pzcode"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="supplierno" label="是否需要厂家编码">
                <div v-for="(item,i) in YoN">
                    <el-radio v-model="formData.supplierno" :label="item.id">{{item.text}}</el-radio>
                </div>
            </el-form-item>
            <el-form-item  prop="pcprefix" label="批次前缀">
                <el-input v-model="formData.pcprefix"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="gid" label="归属组">
                <el-select v-model="formData.gid" size="mini" clearable >
                    <el-option v-for="item in gsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="qynode" label="取样时间点">
                    <el-radio v-model="formData.qynode" :label="1">装卸前</el-radio>
                    <el-radio v-model="formData.qynode" :label="2">装卸后</el-radio>
            </el-form-item>
            <el-form-item  prop="ischeckorder" label="是否需要接收质检单">
                <div v-for="(item,i) in YoN">
                    <el-radio v-model="formData.ischeckorder" :label="item.id">{{item.text}}</el-radio>
                </div>
            </el-form-item>
            <el-form-item  prop="location" label="进厂坐标">
                <el-radio v-model="formData.location" :label="0">任意</el-radio>
                <el-radio v-model="formData.location" :label="1">西区</el-radio>
                <el-radio v-model="formData.location" :label="2">东区</el-radio>
            </el-form-item>



<!--            <div class="formDiv flex jcsb">-->
<!--                <el-form-item class="form-title" prop="lruname" label="录入人" >-->
<!--                    <span>{{formData.lruname}}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item class="form-title" prop="createtime" label="录入日期" >-->
<!--                    <span>{{formData.createtime}}</span>-->
<!--                </el-form-item>-->
<!--            </div>-->
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">保存</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>-->
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion,file_root} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight:0,
                canEdit:true,
                 disabled:false,
                baseerp:'',
                file_root:'',
                formData:{
                    id:0,
                    ywtype:'',
                    pzid:'',
                    pzclass:'',
                    issan:'',
                    ischeck:0,
                    istvnotice:0,
                    tvlocation:'',
                    gettype:1,
                    qynode:'',
                    ischeckorder:0,
                    location:0,
                    pcnumPrefix:'',
                    pcmerge:'',
                    dateformat:'',
                    pzcode:'',
                    supplierno:'',
                    pcprefix:'',
                    unit:1
                },
                id:0,
                gsList:[],
                typeList:[{id:1,text:'生产'},{id:3,text:'采购'},{id:2,text:'销售'},],
                YoN:[{id:0,text:'否'},{id:1,text:'是'}],
                wlList:[],
                wldlList:[],
                searchwl:'',
                searchwldl:'',
            }
        },
        watch: {
            data: {
                handler() {
                    this.id=this.data.id
                    if(this.id==0){
                        this.selectPz()
                        this.selectPzclass()
                    }else{
                        this.getPzcheckDetail()
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {

            this.selectGsz()
            this.baseerp=baseerp;
            this.file_root=file_root;
            this.getDateYYYYMMddHHMMSS();
            this.formData.lruname=sessionStorage.getItem("lruname");
            this.formData.i_lruid=sessionStorage.getItem("userid");
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-20;
                if(this.tableHeight<60)this.tableHeight=60;
            },

            saveForm(){
                if((this.formData.ywtype==2||this.formData.ywtype==3)&&this.formData.qynode==''){
                    this.$message.warning('请填写取样时间')
                    return
                }
                if(this.formData.pzclass==''&&this.formData.pzid==''){
                    this.$message.warning('请选择物料或物料大类')
                    return
                }
                if(this.formData.pzclass!=''&&this.formData.issan===''){
                    this.$message.warning('请选择是否散水')
                    return
                }
                // return;
                this.disabled=true;
                this.savePzcheck()
            },

            cancel(){
                this.$emit('close')
            },
            remoteMethodwl(val){
                this.searchwl=val
                this.selectPz()
            },
            async selectPz(){
                let param={
                    search:this.searchwl
                };
                let res=await API.selectPz(param);
                if ( res.code == 1 ){
                        this.wlList=res.data

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async selectGsz(){
                let param={

                };
                let res=await API.selectGsz(param);
                if ( res.code == 1 ){
                        this.gsList=res.data

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            remoteMethodwldl(val){
                this.searchwldl=val
                this.selectPzclass()
            },
            async selectPzclass(){
                let param={
                    search:this.searchwldl
                };
                let res=await API.selectPzclass(param);
                if ( res.code == 1 ){
                        this.wldlList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getPzcheckDetail(){
                let param={
                    id:this.id
                };
                let res=await API.getPzcheckDetail(param);
                if ( res.code == 1 ){

                    this.formData=res.data;
                    this.searchwl=this.formData.pzname
                    this.searchwldl=this.formData.pzclassname
                    this.selectPz()
                    this.selectPzclass()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async savePzcheck(){

                let param=this.formData;
                // return
                let res=await API.savePzcheck(param);
                if ( res.code == 1 ){
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                this.formData.createtime=`${date.getFullYear()}-${month}-${strDate}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    /deep/.borderred .el-input__inner{
        border-color: red ;
    }
    .jcsb{
        justify-content: space-between;

    }
    .el-form-item__content .el-input,.el-form-item__content .el-input-number,.el-form-item__content .el-select{
        width: 150px;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .el-form-item div{
        display: inline-block;
        padding-right: 30px;
    }
</style>